interface ISSMConfiguration {
  [key: string]: string;
}

type IChatModsConfiguration = ISSMConfiguration & {
  getConfigurationByPath(path: string): string;
};

interface IChatModsGameConfigurationPaths {
  ballcount: string;
  callnames: string;
  callsasimages: string;
  jackpotcalls: string;
  jackpotprize: string;
  prizes: string;
  skins: string;
  stakevalues: string;
  zeroIsValidCall: string;
}

const ConfigurationPaths = {
  features: {
    blings: {
      birthday: '/features/blings/birthday'
    }
  },
  prizes: {
    chat: '/prizes/chat',
    arcade_top_prize_threshold: '/prizes/arcade_top_prize_threshold'
  },
  users: {
    teamleads: '/users/teamleads',
    shiftleads: '/users/shiftleads',
    customerservices: '/users/customerservices',
    cmprefix: '/users/cmprefix',
    shouldShowAlertWordsInCmChat: '/users/showalertcmchat',
    playernotes_beta: '/users/playernotes_beta'
  },
  words: {
    invalidpassword: '/words/invalid/password'
  },
  arcadegames: {
    names: '/arcadegames/names',
    topPrizeDelay: '/arcadegames/top_prize_delay'
  },
  settings : {
    auto_open_training_room_name: '/settings/auto_open_training_room_name'
  },
  featuretoggle: {
    active_directory_authentication_islive: '/featuretoggle/active_directory_authentication_islive',
    enforce_active_directory_authentication_islive: '/featuretoggle/enforce_active_directory_authentication_islive',
    player_notes_islive: '/featuretoggle/player_notes_islive',
    use_player_notes_beta_islive: '/featuretoggle/use_player_notes_beta_islive',
    sin_bin_and_ban_message_islive: '/featuretoggle/sin_bin_and_ban_message_islive',
    technical_issue_referral_islive: '/featuretoggle/technical_issue_referral_islive',
    user_nomination_islive: '/featuretoggle/user_nomination_islive',
    chatcontext_modals_islive: '/featuretoggle/chatcontext_modals_islive',
    arcade_500pound_alert_threshold_removal_islive: '/featuretoggle/arcade_prizethreshold_alert_removal_islive',
    use_gameengine_config_for_winners_service_url_islive: '/featuretoggle/use_gameengine_config_for_winners_service_url_islive',
    ineligible_for_promo_name_styling_change_islive: '/featuretoggle/ineligible_for_promo_name_styling_change_islive',
    use_active_directory_for_chat_user_roles_islive: '/featuretoggle/use_active_directory_for_chat_user_roles_islive',
    use_skin_name_in_gamename_islive: '/featuretoggle/use_skin_name_in_gamename_islive'
  },
  regiontime: {
    details: '/regiontime/details'
  },
  forChatServerUrl(gameName: string) {
    return `/servers/chat/websockets/${gameName}`;
  },
  forGame(gameName: string): IChatModsGameConfigurationPaths {
    const buildPath = (configKey: string) => `/games/${gameName}/${configKey}`;
    return {
      ballcount: buildPath('ballcount'),
      callnames: buildPath('callnames'),
      callsasimages: buildPath('callsasimages'),
      jackpotcalls: buildPath('jackpotcalls'),
      jackpotprize: buildPath('jackpotprize'),
      prizes: buildPath('prizes'),
      skins: buildPath('skins'),
      stakevalues: buildPath('stakevalues'),
      zeroIsValidCall: buildPath('zeroIsValidCall')
    };
  },
  forArcadeGame(arcadeGameName: string) {
    return {
      bonusrounds: `/arcadegames/${arcadeGameName}/bonusrounds`,
      skins: `/arcadegames/${arcadeGameName}/skins`
    };
  }
};

export { IChatModsConfiguration, IChatModsGameConfigurationPaths, ConfigurationPaths };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/config/models/configuration.ts